import { createSignal, onCleanup, onMount } from "solid-js";
import { useWidgetApp } from "~/provider";

export type DeviceType = "mobile" | "tablet" | "desktop";

export function useDeviceType() {
	const [type, setType] = createSignal<DeviceType>("mobile");

	const { parent } = useWidgetApp();

	const onResize = () => {
		const w = parent.documentElement.clientWidth;

		if (w < 768) {
			setType("mobile");
		} else if (w < 1024) {
			setType("tablet");
		} else {
			setType("desktop");
		}
	};

	onMount(() => {
		onResize();
		window.addEventListener("resize", onResize);
	});

	onCleanup(() => {
		window.removeEventListener("resize", onResize);
	});

	return type;
}
